"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualPayAmount = AnnualPayAmount;
exports.Beneficiary = Beneficiary;
exports.BirthDay = BirthDay;
exports.ChildrenAges = ChildrenAges;
exports.CollegePlanInd = CollegePlanInd;
exports.CollegeTerm = CollegeTerm;
exports.DependentAge = DependentAge;
exports.MortgageAmount = MortgageAmount;
exports.NumberOfChildren = NumberOfChildren;
exports.OtherDebtAmount = OtherDebtAmount;
exports.PartnerAge = PartnerAge;
exports.ZipCode = ZipCode;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _LifeInsuranceWizardCalc = require("./LifeInsuranceWizardCalc.config");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function BirthDay(props) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthMonth"
  }, "I was born on "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "Birth Month",
    name: "birthMonth",
    id: "li_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'monthOfBirth').handleBlur(),
    htmlSize: 3
  })), /*#__PURE__*/_react.default.createElement("span", null, " / "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthDay",
    hidden: true
  }, "Birth Month"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "Birth Day",
    id: "li_birthDay",
    name: "birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'dayOfBirth').handleBlur(),
    htmlSize: 3
  })), /*#__PURE__*/_react.default.createElement("span", null, " / "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthYear",
    hidden: true
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "Birth Year",
    id: "li_birthYear",
    name: "birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'yearOfBirth').handleBlur(),
    htmlSize: 5
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid",
    tooltip: true
  }, errors.birthdate)));
}
function ZipCode(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'zipCode';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = 'Enter ZIP';
  var htmlSize = '8';
  var preText = ' and my ZIP code is ';
  var postText = '';
  var className = 'endOfSentence';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    postText: postText,
    className: className,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function Beneficiary(_ref2) {
  var {
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'beneficiary';
  var preText = ' I need life insurance to protect ';
  var className = 'endOfSentence';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _LifeInsuranceWizardCalc.dropdownOptions.beneficiaryArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _LifeInsuranceWizardCalc.calcName,
    className: className
  });
}
function AnnualPayAmount(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'annualPay';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var htmlSize = '10';
  var preText = 'I make ';
  var postText = ' a year. ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    postText: postText,
    prepend: true,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function MortgageAmount(_ref4) {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'mortgageAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var htmlSize = '10';
  var preText = 'My mortgage balance is roughly ';
  var postText = ' ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function OtherDebtAmount(_ref5) {
  var {
    errors,
    touched,
    values
  } = _ref5;
  var fieldName = 'otherDebt';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var htmlSize = '10';
  var preText = 'and I have other debt of ';
  var className = 'endOfSentence';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: className,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function PartnerAge(_ref6) {
  var {
    errors,
    touched,
    values,
    includePeriod
  } = _ref6;
  var fieldName = 'partnerAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = 'My spouse/partner is ';
  var postText = includePeriod ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0years old.\xA0") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0years old\xA0");
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function DependentAge(_ref7) {
  var {
    errors,
    touched,
    values
  } = _ref7;
  var fieldName = 'dependentAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = 'The dependent adult is ';
  var postText = ' years old. ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function NumberOfChildren(_ref8) {
  var {
    values,
    setFieldValue,
    comboScenarioInd
  } = _ref8;
  var fieldName = 'numOfKids';
  var preText = comboScenarioInd ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "and my\xA0") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "My\xA0");
  var postText = ' ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _LifeInsuranceWizardCalc.dropdownOptions.numOfKidsArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _LifeInsuranceWizardCalc.calcName,
    postText: postText
  });
}
function ChildrenAges(props) {
  // Not using common components because this component is more complex and does not fit the template
  var {
    errors,
    touched,
    values
  } = props;
  var {
    numOfKids
  } = values;
  // Specifically not destructuring the childXAge props, where X is the nth child
  // This is so we can dynamically grab values out of the props like so props[{`child{currentChild}Age}]
  var childrenArray = [];
  var multipleChildrenInd = numOfKids > 1 ? true : false;
  for (var i = 0; i < numOfKids; i++) {
    var nthChildPlaceholder = 'child' + (i + 1) + 'Age';
    var firstChildInd = i == 0 ? true : false;
    var lastChildInd = i + 1 == numOfKids;
    var labelText = void 0;
    if (!multipleChildrenInd) {
      labelText = 'child is ';
    } else if (firstChildInd) {
      labelText = 'children are ';
    } else {
      labelText = 'and ';
    }
    childrenArray.push(/*#__PURE__*/_react.default.createElement(ChildAge, {
      key: i,
      errors: errors,
      touched: touched,
      nthChildPlaceholder: nthChildPlaceholder,
      lastChildInd: lastChildInd,
      labelText: labelText,
      values: values
    }));
  }
  return childrenArray;
}
function ChildAge(_ref9) {
  var {
    errors,
    values,
    touched,
    nthChildPlaceholder,
    lastChildInd,
    labelText
  } = _ref9;
  var fieldName = nthChildPlaceholder;
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = labelText;
  var postText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0years old", lastChildInd ? '.' : '', "\xA0");
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function CollegePlanInd(_ref10) {
  var {
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'collegePlanInd';
  var preText = 'I ';
  var postText = ' ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _LifeInsuranceWizardCalc.dropdownOptions.planIndArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _LifeInsuranceWizardCalc.calcName,
    postText: postText
  });
}
function CollegeTerm(_ref11) {
  var {
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'collegeTerm';
  var preText = ' to fund their ';
  var postText = ' college expenses. ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _LifeInsuranceWizardCalc.dropdownOptions.collegeTermArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _LifeInsuranceWizardCalc.calcName,
    postText: postText
  });
}